import { useSelector } from "react-redux";

import { getCurrentSpeciesId } from "selectors";

// Returns the provided species id, or falls back to the current sale's species
// when we are inside a sale context.
export function useResolveSpeciesId(override?: number | null): number | null {
  const saleSpecies = useSelector(getCurrentSpeciesId);
  return override ?? saleSpecies;
}
